import { AbstractControl, ValidationErrors } from '@angular/forms';
import { BaseValidationError } from '@shared/validators/validation-error/base-error';
import { BaseValidator } from '@shared/validators/base-validator';
import { TranslationService } from '@core/translation/translation.service';
import { Boat } from '@shared/models/boat';

export class BoatExistsValidator extends BaseValidator {

    public validationError: BaseValidationError;

    constructor(message?: string) {
        super();

        this.validationError = new BaseValidationError(
            'boatExists',
            message || TranslationService.translate('common.validation.pickBoatFromList')
        );
    }

    public validate({value}: AbstractControl): ValidationErrors {
        return !value || (value instanceof Boat && value.id != null) ?
            this.IS_VALID :
            this.IS_INVALID;
    }
}
